'use strict';

module.exports = {
  products: 'productsLevel',
  attributes: 'attributesLevel',
  topPartners: 'topPartnersLevel',
  modelledProductSwitching: 'modelledProductSwitching',
  originalProductSwitching: 'originalProductSwitching',
};
